var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEntretenimiento(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.339,
    height: 89.551,
    viewBox: "0 0 89.339 89.551",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffffff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Entretenimiento",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    className: "cls-1",
    d: "M53.444,56.842c-.589,4.528-1,9.044-1.8,13.488a28.418,28.418,0,0,1-5.791,13.31c-4.829,5.867-11.59,7.43-18.521,4.359-5.2-2.313-9.159-6.168-12.649-10.51A80.976,80.976,0,0,1,.14,49.077a2.514,2.514,0,0,1,.94-2.9,48.07,48.07,0,0,1,13.746-8.146,70.185,70.185,0,0,1,20.609-5.058c.4-.038.8-.093,1.271-.153-.148-2.724-.364-5.376-.424-8.049A84.478,84.478,0,0,1,38.655,3.128,2.846,2.846,0,0,1,41.2.7C48.716-.7,56.083.128,63.4,1.772a61.065,61.065,0,0,1,22.6,9.786c3.863,2.775,3.931,2.813,2.453,7.269-3.813,11.467-9.32,21.96-18.012,30.539-3.389,3.351-7.227,6.1-12.039,7.036A44.5,44.5,0,0,1,53.444,56.842ZM41.71,6.432c1.123-.089,2.216-.157,3.3-.263,1.195-.119,2.177.2,2.313,1.517s-.8,1.822-1.97,1.949c-.983.106-1.97.233-2.965.258-1.195.034-1.694.568-1.83,1.771A75.272,75.272,0,0,0,40.9,35.839c.953,4.825,2.41,9.489,5.715,13.323,3.436,3.99,8.519,5.312,13.276,3.075a28.908,28.908,0,0,0,7.265-4.719C75.9,39.47,81.14,29.218,85.033,18.149c.678-1.923.25-2.927-1.334-3.969A62.253,62.253,0,0,0,43.934,3.805c-1.733.127-2.326.89-2.224,2.635Zm2.207,45.048c-3.652-4.338-5.321-9.578-6.562-15.25-2.9.424-5.736.69-8.515,1.237A59.4,59.4,0,0,0,5.473,47.1c-2.084,1.491-2.084,1.606-.813,4.041.907-.644,1.8-1.271,2.69-1.911.966-.695,1.957-.94,2.749.153s.284,1.97-.682,2.673L5.6,54.847c1.508,3.143,2.872,6.219,4.431,9.2A56.685,56.685,0,0,0,22.321,80.451c3.215,2.864,6.74,5.312,11.209,5.507,5.753.28,9.32-3.075,11.751-7.828,3.469-6.808,4.207-14.212,4.274-21.715a1.55,1.55,0,0,0-.631-1.068A25.8,25.8,0,0,0,46.6,54a9.216,9.216,0,0,1-8.35,3.012,8.269,8.269,0,0,1-6.282-4.236,2.639,2.639,0,0,1,.4-2.389c.729-.847,1.694-.39,2.385.424.186.22.326.483.513.7a5.458,5.458,0,0,0,8.65-.021Z",
    transform: "translate(0 0.013)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    className: "cls-1",
    d: "M122.451,93.694a9.078,9.078,0,0,1-8.472-6.121c-.381-1.14-.347-2.148.89-2.605s1.906.246,2.393,1.368c1.775,4.067,5.427,5.033,9.057,2.406.97-.7,1.9-1.012,2.749.021s.339,1.957-.534,2.715a9.074,9.074,0,0,1-6.083,2.216Z",
    transform: "translate(-65.572 -48.887)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    className: "cls-1",
    d: "M103.829,38.27c5.405,0,9.459,3.732,9.8,8.4.085,1.148-.153,2.165-1.487,2.343s-1.8-.627-2-1.851c-.7-4.512-3.914-6.354-8.252-4.706-1.072.424-1.987.39-2.542-.707a1.689,1.689,0,0,1,1.14-2.487C101.8,38.778,103.159,38.469,103.829,38.27Z",
    transform: "translate(-57.138 -22.053)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    className: "cls-1",
    d: "M154.254,53.339a8.955,8.955,0,0,1,7.646,4.118c.678,1,.758,2-.347,2.724s-1.822.14-2.542-.724c-2.868-3.575-6.511-3.558-9.489.038-.712.847-1.508,1.364-2.542.644-1.1-.767-.932-1.762-.258-2.741A8.934,8.934,0,0,1,154.254,53.339Z",
    transform: "translate(-84.259 -30.738)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    className: "cls-1",
    d: "M119.187,16.872c-.674.445-1.406,1.3-2.008,1.22s-1.195-1.059-1.779-1.644c.555-.546,1.076-1.491,1.694-1.542s1.385.707,2.084,1.114Z",
    transform: "translate(-66.515 -8.585)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    className: "cls-1",
    d: "M71.412,165.27a9.26,9.26,0,0,1,5.816,2.317c.89.784,1.326,1.694.424,2.715-.8.9-1.72.665-2.639,0-3.813-2.715-7.235-1.783-9.154,2.457-.453,1-1.072,1.724-2.262,1.326-1.271-.424-1.347-1.466-1.025-2.576C63.584,168.007,67.345,165.283,71.412,165.27Z",
    transform: "translate(-35.972 -95.253)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    className: "cls-1",
    d: "M29.4,135.346a33.488,33.488,0,0,1-3.317-1.012c-.991-.385-1.694-1.165-1.161-2.338s1.5-1.326,2.609-.8a5.588,5.588,0,0,0,5.507-.169,5.507,5.507,0,0,0,2.715-4.431c.127-1.271.606-2.211,2.046-1.978s1.542,1.368,1.406,2.542C38.658,131.86,34.727,135.4,29.4,135.346Z",
    transform: "translate(-14.258 -71.798)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    className: "cls-1",
    d: "M30.628,111.313c-.695.453-1.356,1.186-2.118,1.271a1.368,1.368,0,0,1-1.572-1.694,2.426,2.426,0,0,1,1.639-1.55c.665-.025,1.368.788,2.055,1.237Z",
    transform: "translate(-15.501 -63.015)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntretenimiento);
export default __webpack_public_path__ + "static/media/entretenimiento.6dc9c255f54157c5161314d4b65de416.svg";
export { ForwardRef as ReactComponent };